import * as React from 'react';

import PropTypes from 'prop-types';

import {UpgradeArrow} from 'shells/limits/upgrade-arrow';

import {
    getDashTypes,
    getDashLabel,
    getDashEntityName,
    getDashIsDisabled,
    getDashByline,
    getDashIsPro,
    getIsDashSpecialCard,
} from '../../../dashboard-constants';

import styles from './new-dash-selector.module.css';

export class NewDashSelector extends React.Component {
    static propTypes = {
        onSelect: PropTypes.func.isRequired,
    };

    render() {
        let dashTypes = getDashTypes().filter((dashType) => !getIsDashSpecialCard(dashType));
        if (!NutClientConfig.hasQuotas) {
            // sort disabled dashTypes to the end
            dashTypes = dashTypes.sort((type) => {
                if (getDashIsPro(type)) {
                    return 1;
                } else {
                    return -1;
                }
            });
        }

        return (
            <div className={styles.container}>
                {dashTypes.map((dashType) => {
                    const dashEntity = getDashEntityName(dashType);
                    const dashLabel = getDashLabel(dashType);
                    const dashByline = getDashByline(dashType);
                    const isPro = getDashIsPro(dashType);
                    const isDisabled = getDashIsDisabled(dashType);

                    return (
                        <div key={dashLabel} className={styles['content-container']}>
                            <button
                                disabled={isDisabled}
                                onClick={() => this.props.onSelect(dashEntity)}
                                className={
                                    isDisabled
                                        ? styles['dash-container-disabled']
                                        : styles['dash-container']
                                }
                            >
                                <div className={styles['dash-image-container']}>
                                    <img
                                        src={`/include/images/dashboard/${dashEntity}.svg`}
                                        className={styles['dash-image']}
                                    />
                                </div>
                                <div className={styles['dash-label']}>
                                    <span className={styles['dash-label-text']}>{dashLabel}</span>
                                    {isPro && isDisabled ? (
                                        <div className={styles['upgrade-arrow']}>
                                            <UpgradeArrow featureName={dashLabel} />
                                        </div>
                                    ) : undefined}
                                </div>
                                <div className={styles['dash-byline']}>
                                    <span>{dashByline}</span>
                                </div>
                            </button>
                        </div>
                    );
                })}
            </div>
        );
    }
}
